import { fromJS, Map } from 'immutable';
import { Reducer } from 'redux';

import { TypedMap } from 'utils/typed-map';

import { INIT, INIT_FAILED, INIT_SUCCESS } from './constants';
import { DonationsSeedActions } from './actions';

type MutableState = {
  loading: boolean;
  error: unknown;
};

export type DonationsSeedState = Map<string, unknown> & TypedMap<MutableState>;

export const initialState: DonationsSeedState = fromJS({
  loading: false,
  error: false,
});

const donationsSeedPageReducer: Reducer<DonationsSeedState, DonationsSeedActions> = (
  state = initialState,
  action: DonationsSeedActions
) => {
  switch (action.type) {
    case INIT:
      return state.merge({
        loading: true,
      }) as DonationsSeedState;

    case INIT_SUCCESS:
      return state.set('loading', false) as DonationsSeedState;

    case INIT_FAILED:
      return state.merge({
        loading: false,
        error: action.error,
      }) as DonationsSeedState;

    default:
      return state;
  }
};

export default donationsSeedPageReducer;
